import { Reducer } from "redux";

import { DocumentUploadResponse } from "../models/Api/TabSessionStorage";
import { DocumentUploadActionDispatchTypes } from "../constants/DocumentUpload";
import { DocumentUploadDispatchTypes } from "../models/DispatchTypes/TabSessionStorage";

export const initialState: DocumentUploadResponse = {
  loading: false,
  response: [
    {
      blobId: -1,
      originalDocumentName: "",
      blobContentLength: -1,
      blobContainerName: "",
      blobContentType: "",
      blobFileName: "",
      blobStorageAccount: "",
      blobUId: "",
      blobUri: "",
      dateCreated: "",
      dateUpdated: "",
      errorMessage: "",
      originalFileName: "",
      isActive: false,
      userCreated: "",
      userUpdated: "",
      mediaType: "",
    },
  ],
};

const DocumentDownloadReducer: Reducer<
  DocumentUploadResponse,
  DocumentUploadDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case DocumentUploadActionDispatchTypes.DOCUMENT_UPLOAD_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case DocumentUploadActionDispatchTypes.DOCUMENT_UPLOAD_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case DocumentUploadActionDispatchTypes.DOCUMENT_UPLOAD_RESET: {
      return initialState;
    }
  }
  return state;
};

export default DocumentDownloadReducer;
